import { ApiGetDashboardList, ApiGetDashboardHeader } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, SidebarOpen } from "utils/Constant";
import { useEffect, useState } from "react";
import { money } from "utils/helpers";
import { format } from 'date-fns';
import {
    CalendarCheck,
    CalendarRange,
    Clock,
    TrophyIcon
} from "lucide-react"


export default function Dashboard(){
    const { fetch: getDashboardList, data: dashboardList } = useFetch(ApiGetDashboardList)
    const { fetch: getDashboardHeader, data: dashboardHeader } = useFetch(ApiGetDashboardHeader)

    const [isAdmin, setIsAdmin] = useState(localStorage.getItem("IsAdmin"))

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const viewSalesBtnClick = () => {
        window.location.href = "/sales"
    }

    // Api Function
    async function fGetTransactionList(){
        await getDashboardList({
            data: {  }
        }).then((response) => {
            checkResponse(response)
        })
    }
    async function fGetTransactionHeader(){
        await getDashboardHeader({
        }).then((response) => {
            checkResponse(response)
        })
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    useEffect(() => {
        setLoading({isOpen: true})

        fGetTransactionHeader().then(() => {
            fGetTransactionList().then(() => {
                setLoading({isOpen: false})
            })
        })
    }, [])

    const DashboardCard = ({icon, title, amount, count}) => {
        return(
            <div className="flex flex-row gap-4 border rounded-lg w-full lg:w-4/12 xl:w-3/12 p-2 sm:p-3 shadow-md bg-white">
                <div className="bg-black flex justify-start items-center gap-4 rounded-md px-3">
                    {icon}
                </div>
                <div className="flex flex-col justify-between w-full">
                    <div>
                        <span className="text-sm sm:text-md">{title}</span>
                    </div>
                    <div className="flex justify-between">
                        <div>
                            <span className="text-md sm:text-xl tracking-wide font-semibold">Rp {amount}</span>
                        </div> 
                        <div>
                            <span className="text-md sm:text-xl tracking-wide font-semibold">{count}</span>
                        </div> 
                    </div>                    
                </div>
            </div>
        )
    }

    return(
        <div>
            <div>
                <span className="font-semibold text-xl sm:text-2xl">Dashboard</span>
                <hr />
            </div>

            {/* SALES SUMMARY */}
            <div className={`flex flex-col sm:flex-row sm:flex-wrap xl:flex-nowrap gap-4 mt-4
                ${localStorage.getItem("SidebarState") === SidebarOpen ? '' : 'lg:flex-nowrap'}
            `}>
                <DashboardCard 
                    icon={<TrophyIcon className="w-6 h-6 sm:w-8 sm:h-8 text-white" />} 
                    title={"All Time Sales"}
                    amount={money(dashboardHeader?.data?.allSales?.totalTarrif ?? "0")}
                    count={dashboardHeader?.data?.allSales?.totalTransaction}
                />
            
                <DashboardCard 
                    icon={<CalendarCheck className="w-6 h-6 sm:w-8 sm:h-8 text-white" />} 
                    title={"Annual Sales"}
                    amount={money(dashboardHeader?.data?.yearlySales?.totalTarrif ?? "0")}
                    count={dashboardHeader?.data?.yearlySales?.totalTransaction}
                />

                <DashboardCard 
                    icon={<CalendarRange className="w-6 h-6 sm:w-8 sm:h-8 text-white" />} 
                    title={"Monthly Sales"}
                    amount={money(dashboardHeader?.data?.monthlySales?.totalTarrif ?? "0")}
                    count={dashboardHeader?.data?.monthlySales?.totalTransaction}
                />

                <DashboardCard 
                    icon={<Clock className="w-6 h-6 sm:w-8 sm:h-8 text-white" />} 
                    title={"Daily Sales"}
                    amount={money(dashboardHeader?.data?.dailySales?.totalTarrif ?? "0")}
                    count={dashboardHeader?.data?.dailySales?.totalTransaction}
                />                
            </div>
            
            <div>
                <button className="w-full py-2 bg-black text-white mt-4 rounded-md hover:bg-gray-400 hover:text-black hover:shadow-md" onClick={viewSalesBtnClick}>
                    View Sales
                </button>
            </div>

            <div className="mt-5">
                <div>
                    <span className="font-semibold text-xl">Last Transaction</span>
                    <hr />
                </div>

                {/* Mobile View */}
                <div className="sm:mt-4 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                    <div className="sm:hidden flex flex-col">
                        { dashboardList?.data?.listData?.map((data, i) => {
                            return(
                                <div className="border-b py-2">
                                    <div className="flex justify-between items-center text-sm">
                                        <span>{ data.vehicleType }</span>
                                        <span className="text-sm">{ format(data.transactionDate, 'dd MMM yyyy') }</span>
                                    </div>
                                    <div className="flex justify-between items-center text-sm">
                                        <span>{ data.licensePlateNumber }</span>
                                        <span className="text-sm">{ data.employeeNameIn } - { data.employeeNameOut ? data.employeeNameOut : ''}</span>
                                    </div>
                                    <div className="flex justify-between items-center text-sm">
                                        <span>{ data.locationName }</span>
                                        <span className="text-sm">{ data.paymentStatus === "1" ? "Closed" : "Open" }</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    {/* Web View */}
                    <table className="w-full bg-white hidden sm:table">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left">Date</th>
                                <th className="font-semibold text-left px-2">Location</th>
                                <th className="font-semibold text-left px-2">Attendant</th>
                                <th className="font-semibold text-left px-2">Vehicle Type</th>
                                <th className="font-semibold text-left px-2">Amount</th>
                                <th className="font-semibold text-left px-2">Transaction Status</th>
                            </tr>
                        </thead>
                        <tbody className="">
                            { dashboardList?.data?.listData?.length === 0 && (
                                <tr className="border-t">
                                    <td colSpan={9} className="text-center py-3">
                                        <span>No Data Available</span>
                                    </td>
                                </tr>
                            )}
                            { dashboardList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-t hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ i + 1 }</td>
                                        <td className="px-2">
                                            <span>{ format(data.transactionDate, 'dd MMM yyyy') }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.locationName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.employeeNameIn } { data.employeeNameOut ? ' - ' + data.employeeNameOut : ''}</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.vehicleType.toUpperCase() } { data.vehicleModel }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.tarrif) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.paymentStatus === "1" ? "Closed" : "Open" }</span>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}